import { formatDate } from "@src/utils/dates"
import { FORM_SUBMIT_DATE_FORMAT } from "@src/utils/constants/forms"
import AffiliateReferrals from "@src/services/affiliates/referrals"
import { formatNumber } from "@src/utils/numbers"
import { SITE_DOMAIN } from "@src/utils/constants"
export const formatBookingRequestData = (data, product, localeCurrency) => {
  let netlifyEndDate
  let userNationality
  if (data.travel_date) {
    if (product.durationNights) {
      netlifyEndDate = new Date(data.travel_date) // avoid making changes to the same reference date value
      netlifyEndDate.setDate(
        data.travel_date.getDate() + product.durationNights,
      )
      netlifyEndDate = formatDate(netlifyEndDate, FORM_SUBMIT_DATE_FORMAT)
    }
    data.travel_date = formatDate(data.travel_date, FORM_SUBMIT_DATE_FORMAT)
  }
  if (data.nationality) {
    data.nationality = data.nationality.value
    userNationality = data.nationality
  }

  const { details, ...values } = data
  const submitData = {
    product: (product && product.id) || "",
    currency: (localeCurrency && localeCurrency.code) || "",
    "booking-date": data.travel_date,
    ...values,
    // Provide values for the hidden fields sent to Netlify - need to be added here instead of in the hidden field as these load in as a result of a client query
    netlify_requested_date: data.travel_date,
    netlify_tour_title: product.title,
    netlify_traveller_count: data.traveller_count || 1,
    netlify_itinerary_start: product.itinerary.locationStart,
    netlify_itinerary_end: product.itinerary.locationEnd,
    netlify_suggested_end_date: netlifyEndDate,
    netlify_selected_nationality: userNationality,
    netlify_tour_url: `${SITE_DOMAIN}/${product.id}`,
    booking_tour_operator: product.operator,
    booking_tour_cms_link: `cms.10adventures.com/${product.id}`,
  }
  submitData["travellers-num"] = data.traveller_count || 1
  // travellers[0] is required due to how the back-end was set up to received the legacy booking request form data, which captured and generated this info for several travellers. In the future, this can be refactored along with a back-end change.
  const baseId = `travellers[0]`
  submitData[`${baseId}[firstName]`] = values["name_first"]
  submitData[`${baseId}[lastName]`] = values["name_last"]
  submitData[`${baseId}[phone]`] = values["phone_number"]
  submitData[`${baseId}[nationality]`] = values["nationality"]

  for (const detail in details) {
    submitData[`details[${detail}]`] = details[detail]
  }

  submitData["contact-email"] = data.email
  submitData["contact-email-confirm"] = data["email-confirm"]
  submitData["contact-promo"] = (data.subscribe_newsletter && "on") || ""

  submitData["agree-terms-10adventures"] =
    (data.agree_terms_10adventures && "on") || ""

  const refCode = AffiliateReferrals.getActiveReferral()

  if (refCode) {
    submitData.netlify_affiliate_code = refCode
  }
  return submitData
}

export const generateBookingRequestDataLayer = (
  submitData,
  product,
  localeCurrency,
  convertCurrency,
) => {
  const data = {}
  if (product) {
    if (product.id) {
      data.product = product.id
    }
    if (submitData.traveller_count) {
      data.guest_count = submitData.traveller_count
    }
    const quantity = data.guest_count || 1
    if (product.price) {
      data[`price_${process.env.GATSBY_ANALYTICS_CURRENCY}`] = parseFloat(
        formatNumber(
          convertCurrency(
            product.price.amount,
            product.price.currency.code,
            process.env.GATSBY_ANALYTICS_CURRENCY,
          ),
          2,
          "",
        ),
      )
      data[`total_${process.env.GATSBY_ANALYTICS_CURRENCY}`] =
        quantity * data[`price_${process.env.GATSBY_ANALYTICS_CURRENCY}`]

      if (
        localeCurrency &&
        localeCurrency.code &&
        localeCurrency.code !== process.env.GATSBY_ANALYTICS_CURRENCY
      ) {
        data[`price_${localeCurrency.code}`] = parseFloat(
          formatNumber(
            convertCurrency(
              product.price.amount,
              product.price.currency.code,
              localeCurrency.code,
            ),
            2,
            "",
          ),
        )
        data[`total_${localeCurrency.code}`] =
          quantity * data[`price_${localeCurrency.code}`]
      }
    }
  }
  data["newsletter"] = submitData.subscribe_newsletter ? "yes" : "no"
  return data
}
